import AdminAttestationInfoIndex from '@/pages/admin/attesation_info/Index'
import AdminAttestationInfoStudentView from '@/pages/admin/student/View'
import AdminAttestationInfoStudentIndex from '@/pages/admin/attesation_info/student/Index'
import AdminAttestationInfoStudentResult from '@/pages/admin/attesation_info/student/Result'
import AdminAttestationInfoStudentFilter from '@/pages/admin/attesation_info/student/Filter'

export default [
  {
    path: '/admin/attestation_info/:id',
    name: 'AdminAttestationInfoIndex',
    component: AdminAttestationInfoIndex,
    props: true,
    meta: {
      roles: ['ROLE_ADMIN'],
      title: 'Аттестация группы'
    }
  },
  {
    path: '/admin/attestation_info/student/:id/print',
    name: 'AdminAttestationInfoStudentPrint',
    component: AdminAttestationInfoStudentView,
    props: true,
    meta: {
      roles: ['ROLE_ADMIN'],
      title: 'Информация об аттестуемом'
    }
  },
  {
    path: '/admin/attestation_info/student/:id',
    name: 'AdminAttestationInfoStudentIndex',
    component: AdminAttestationInfoStudentIndex,
    props: true,
    meta: {
      roles: ['ROLE_ADMIN'],
      title: 'Результаты аттестуемого'
    }
  },
  {
    path: '/admin/attestation_info/student/:id/filter',
    name: 'AdminAttestationInfoStudentFilter',
    component: AdminAttestationInfoStudentFilter,
    props: true,
    meta: {
      roles: ['ROLE_ADMIN'],
      title: 'Фильтр аттестуемого'
    }
  },
  {
    path: '/admin/attestation_info/student/result/:id',
    name: 'AdminAttestationInfoStudentResult',
    component: AdminAttestationInfoStudentResult,
    props: true,
    meta: {
      roles: ['ROLE_ADMIN'],
      title: 'Результаты аттестуемого'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/attestation_info.js